import { motion, useReducedMotion } from "framer-motion";

export const FloatingIcons = ({ items, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      {items.map(({ Icon, x, y, size = 24, dur = 9, delay = 0, opacity = "text-ink/10" }, i) => (
        <motion.div
          key={i}
          className={`absolute ${opacity}`}
          animate={reduce ? {} : { y: [0, -20, 0], x: [0, 8, 0], rotate: [0, 8, 0], rotateY: [0, 25, 0] }}
          style={{ left: x, top: y, transformPerspective: 600 }}
          transition={{ duration: dur, delay, repeat: Infinity, ease: "easeInOut" }}
        >
          <Icon style={{ width: size, height: size }} />
        </motion.div>
      ))}
    </div>
  );
};
